import { coreServiceUrl } from '../../../config/environment';
import { Color } from '../../../interfaces/ColorValue';
import { ColorMapper } from '../../../interfaces/mappers/ColorMapper';
import { callApi } from '../../../utils/callApi';

export interface ArticleColorsMapping {
  articleNumber: string;
  colors: Color[];
}

interface ArticleColorsDto {
  articleNumber: string;
  colors: CoreServiceAPI.ColorDto[];
}

interface ArticleColorMapDto {
  articleColors: ArticleColorsDto[];
}

export const getMultipleColors = async (
  articleNumbers: string[],
): Promise<ArticleColorsMapping[]> => {
  const { data } = await callApi<ArticleColorMapDto>(
    `${coreServiceUrl}/v2/products/articles/get-multiple-colors`,
    'post',
    { articleNumbers: articleNumbers },
  );

  return data.articleColors.map((colorMapping) => ({
    articleNumber: colorMapping.articleNumber,
    colors: colorMapping.colors.map((v) => ColorMapper.toColorDomain(v)),
  }));
};
